import { renderColorImage } from './renderColorImage.js';
import { renderGrayscaleImage } from './renderGrayscaleImage.js';
import { renderLabelMapImage } from './renderLabelMapImage.js';
import { renderPseudoColorImage } from './renderPseudoColorImage.js';
import renderToCanvas from './renderToCanvas.js';
import { renderWebImage } from './renderWebImage.js';

/**
 * @module rendering
 */
export default {
  colorImage: renderColorImage,
  grayscaleImage: renderGrayscaleImage,
  webImage: renderWebImage,
  pseudoColorImage: renderPseudoColorImage,
  labelMapImage: renderLabelMapImage,
  toCanvas: renderToCanvas,
};
